// src/contexts/languages/LanguageContext.ts
// The designer's pages import `useTranslation` from this path (his app keeps its context at contexts/languages/). This repo's own
// context lives one folder up; this module re-exports it under his path with the shape his files expect, so his files import it
// unchanged. His context file itself is not ported (WU-141 S-7): the repo's provider stays the one provider, its default stays 'es'.
import { ENGLISH_AVAILABLE as REPO_ENGLISH_AVAILABLE, useTranslation as useRepoTranslation } from '../LanguageContext';

export interface LanguageContextType {
  language: 'en' | 'es';
  setLanguage: (lang: 'en' | 'es') => void;
  t: (key: string) => string;
}

export const useTranslation = (): LanguageContextType => useRepoTranslation();

// WU-164 D6 (QA-F03): the one flag of ../LanguageContext.js, typed for TS readers (the landing menu's switch).
export const ENGLISH_AVAILABLE: boolean = REPO_ENGLISH_AVAILABLE;
